import {combineReducers} from 'redux'

import authentication from './authentication'
import products from './products'


export default combineReducers({
    authentication,
    products
})